import { render, staticRenderFns } from "./DevApp.vue?vue&type=template&id=95b28ee6"
import script from "./DevApp.vue?vue&type=script&lang=js"
export * from "./DevApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports